import React from 'react'

const FavoriteArtists = ({ artists, onToggleSeen, onToggleFavorite }) => {
  const favoriteArtists = artists.filter(artist => artist.favorite && artist.name.trim())

  if (favoriteArtists.length === 0) return null

  return (
    <div className="mt-4">
      <h4 className="text-sm font-medium text-white mb-3">⭐ Favorite Performances</h4>
      <div className="bg-gradient-to-r from-yellow-500/10 to-orange-500/10 border border-yellow-500/30 rounded-xl p-4">
        <div className="text-yellow-200 leading-relaxed">
          {favoriteArtists.map((artist, index) => {
            const originalIndex = artists.findIndex(a => a.name === artist.name)

            return (
              <span key={index} className="inline-block group relative mr-2 mb-1">
                <span
                  onClick={() => onToggleSeen(originalIndex)}
                  className={`inline-block px-2 py-1 rounded-full border-2 cursor-pointer transition-all duration-300 ${
                    artist.seen
                      ? 'bg-green-500/30 border-green-400/60 text-green-200'
                      : 'border-yellow-400/30 hover:border-yellow-400/60 text-yellow-200'
                  }`}
                  title={`Click to mark as ${artist.seen ? 'not seen' : 'seen'}`}
                >
                  {artist.name}
                </span>

                <FavoriteToggleButton
                  onClick={() => onToggleFavorite(originalIndex)}
                />

                {index < favoriteArtists.length - 1 && (
                  <span className="text-yellow-400">, </span>
                )}
              </span>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const FavoriteToggleButton = ({ onClick }) => (
  <button
    type="button"
    onClick={(e) => {
      e.stopPropagation()
      onClick()
    }}
    className="absolute -top-1 -right-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
  >
    <div className="w-4 h-4 flex items-center justify-center">
      <svg className="w-4 h-4 text-yellow-400 fill-current hover:text-red-400 transition-colors" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    </div>
  </button>
)

export default FavoriteArtists